"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("@styled-system/prop-types"));

var _tags = _interopRequireDefault(require("../../utils/helpers/tags"));

var _preview = _interopRequireWildcard(require("./preview.style"));

var _utils = require("../../style/utils");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const marginPropTypes = (0, _utils.filterStyledSystemMarginProps)(_propTypes2.default.space);

const Preview = props => {
  const marginProps = (0, _utils.filterStyledSystemMarginProps)(props);

  if (isLoading(props.loading, props.children)) {
    const previews = [];

    for (let i = 1; i <= props.lines; i++) {
      previews.push(createPreview(props, i));
    }

    return /*#__PURE__*/_react.default.createElement(_preview.StyledPreview, marginProps, previews);
  }

  return /*#__PURE__*/_react.default.createElement(_preview.StyledPreview, marginProps, props.children);
};

function isLoading(loading, children) {
  if (typeof loading !== "undefined") {
    return loading;
  }

  return !children;
}

function createPreview(allProps, index) {
  const {
    height,
    lines
  } = allProps;
  let {
    width
  } = allProps;

  if (!width && lines > 1 && lines === index) {
    width = "80%";
  }

  return /*#__PURE__*/_react.default.createElement(_preview.default, _extends({
    key: index,
    style: {
      height,
      width
    }
  }, (0, _tags.default)("preview", allProps)));
}

Preview.propTypes = { ...marginPropTypes,

  /** Children content to render in the component. */
  children: _propTypes.default.node,

  /** A custom height to be applied to the component. */
  height: _propTypes.default.string,

  /** The number of lines to render. */
  lines: _propTypes.default.number,

  /* Provides more control over when in a loading state. */
  loading: _propTypes.default.bool,

  /** A custom width */
  width: _propTypes.default.string
};
Preview.defaultProps = {
  lines: 1
};
var _default = Preview;
exports.default = _default;